import { Div, Ref, Text } from "@tblabs/truffle";
import { Opinion } from "../../../Models/Description/Opinion/Opinion";
import { Svg } from "../../../Pages/Components/Utils/Svg";
import { Icons } from "../../Utils/Icons";


export class StarRate extends Div
{
    constructor(rating: Ref<number>)
    {
        super();

        for (let i = 1; i <= 5; i++)
        {
            this.Append(
                new Svg(rating.value >= i ? Icons.Star : Icons.EmptyStar));
        }
    }
}

export class OpinionPrinter extends Div
{
    constructor(opinion: Opinion)
    {
        super("card product-reviews__card");

        this.Append(
            new Div("card__content product-reviews__content").Append(
                new Div("product-reviews__header").Append(
                    new StarRate(opinion.Rate).Class("product-reviews__stars"),
                    new Text(opinion.Author).Class("product-reviews__name"),
                ),
                new Text(opinion.Comment).Class("product-reviews__text"),
                // opinion.Advantages.value && new Text(opinion.Advantages, v => `Zalety: ${v}`).Class("product-reviews__text").Color("green").FontSize(14).DisplayBlock().Margin(4),
                // opinion.Disadvantages.value && new Text(opinion.Disadvantages, v => `Wady: ${v}`).Class("product-reviews__text").Color("red").FontSize(14).DisplayBlock().Margin(4),
            )
        )
    }
}
